import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import HEA from './HEA'
import HVAC from './HVAC'
import HealthyHome from './HealthyHome'

import urlPathSetter from '@utils/urlPathSetter'
import { useFormContext } from '@context/FormContext'

const Eligibility = ({ currentStepIndex, setValidationSchema, setBlockNextStepUntilHowHeated, values: valuesProp }) => {
  const { values: valuesFromContext, setFieldValue } = useFormContext()
  const values = valuesFromContext !== undefined && valuesFromContext !== null ? valuesFromContext : (valuesProp || {})

  if (!values) return null

  useEffect(() => {
    if (values.step !== 'eligibility') {
      setFieldValue('step', 'eligibility')
    }
  }, [values.step, setFieldValue])

  const valuesForUrl = { ...values, step: 'eligibility' }
  urlPathSetter(valuesForUrl)
  const props = { currentStepIndex, setValidationSchema, setBlockNextStepUntilHowHeated, values }

  if (values.path === 'hea') return <HEA {...props} />
  if (values.path === 'hvac') return <HVAC {...props} />
  // HealthyHome: direct entry via /HealthyHome URL — mirrors HEA without gas/electric provider questions
  if (values.path === 'healthyhome') return <HealthyHome {...props} />

  return (
    <div className="max-w-2xl mx-auto px-4 py-8">
      <p className="text-stone-500 text-sm text-center">Please select a service path first.</p>
    </div>
  )
}

Eligibility.info = {
  title: 'Eligibility',
  key: 'eligibility',
}

Eligibility.propTypes = {
  currentStepIndex: PropTypes.number.isRequired,
  setValidationSchema: PropTypes.func.isRequired,
  setBlockNextStepUntilHowHeated: PropTypes.func,
  values: PropTypes.object.isRequired,
}

export default Eligibility
